var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegrationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1526_4341)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.536 15.536C10.7517 15.836 9.89699 16 9 16C5.1 16 2 12.9 2 9C2 5.1 5.1 2 9 2C12.9 2 16 5.1 16 9C16 9.89699 15.836 10.7517 15.536 11.536L21.7 17.7C21.9 17.9 22 18.1 22 18.4V21C22 21.6 21.6 22 21 22H18.4C18.1 22 17.9 21.9 17.7 21.7L17 21V19H15V17H13L11.536 15.536ZM7.5 10C6.1 10 5 8.9 5 7.5C5 6.1 6.1 5 7.5 5C8.9 5 10 6.1 10 7.5C10 8.9 8.9 10 7.5 10Z",
    fill: "#ffffffff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1526_4341"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationsIcon);
export default __webpack_public_path__ + "static/media/integrationsIcon.bcd63ae3c35af2b45b7cd511e00c6f02.svg";
export { ForwardRef as ReactComponent };